<template xmlns:v-on="http://www.w3.org/1999/xhtml">
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="$store.getters.role == 1 || $store.getters.role == 2">
            <div class="container-fluid xyz">
                <div class="page-header-top-container">
                    <!-- <div class="page-name">List Tickets</div> -->
                    <div class="page-name">Hourly Report</div>
                    <button type="button" class="btn btn-secondary" v-on:click="exportTicket($event)">Export</button>
                </div>
                        
                <!--page content-->
                <div class="admin-page-content">
                    <div class="card">
                        <h5 class="card-header" style="background:#f5f5f5;">
                            <div class="selectdate">
                                <div class="selectbox1">
                                    <v-select v-model="selectedLocation" name="location"
                                            placeholder="Type location here"
                                            label="location_name"
                                            :options="locationOptions" class=""
                                            v-on:change="loadTickets"
                                    @input="changeLocation()">
                                    </v-select>
                                    <span class="text-danger">{{locationError}}</span>
                                    <!--<span v-show="errors.has('location')" class="danger">-->
                                        <!--{{ errors.first('location') }}-->
                                    <!--</span>-->
                                </div>

                                <!--
                                <div>
                                    <input type="radio" id="number_open" value="open" v-model="time_considered"> Open
                                    <input type="radio" id="number_close" value="close" v-model="time_considered"> Close
                                </div>
                                -->
                                <!--
                                    :min-datetime="minDateTime"
                                    :max-datetime="maxDateTime"
                                -->
                                <div class="selectbox1">
                                    <VueCtkDateTimePicker v-model="date_picker_dates"
                                                          range
                                                          :only-date="date_picker_options.onlyDate"
                                                          :only-time="false"
                                                          :output-format="date_picker_options.outputFormat"
                                                          :format="date_picker_options.inputFormat"
                                                          :formatted="date_picker_options.formatted"
                                                          :noClearButton="date_picker_options.noClearButton"
                                                          :custom-shortcuts="date_picker_options.customShortcuts"
                                                          @input="changeDatePickerDate()"
                                                          :maxDate="date_picker_options.maxDate"
                                    ></VueCtkDateTimePicker>
                                    <span class="text-danger">{{datePickerError}}</span>
                                </div>
                                
                                <div class="selectbtn">
                                    <button type="button" class="btn btn-warning applybtn" v-on:click="loadTickets()">Apply Filter</button>
                                    <button type="button" class="btn btn-primary clearbtn" v-on:click="clearFilter()">Clear Filter</button>
                                </div>
                            </div>

                        </h5>
                    </div>

                    <!-- List Content Here -->
                    <div class="app-filter-good-table-container hourly-report-table">
                        <vue-good-table
                            ref="ticketList"
                            mode="remote"
                            :totalRows="totalRecords"
                            :columns="columns"
                            :rows="rows"
                            :sort-options="{
                                enabled: false,
                            }"                            
                            :pagination-options="{
                                enabled: false,
                                mode: 'pages',
                                pageLabel: 'Page',
                                position: 'bottom',
                                perPage: serverParams.perPage,
                                perPageDropdown: [25, 50, 100, 200 ,500],
                                dropdownAllowAll: false,
                            }"
                            :search-options="{
                                enabled: false,
                            }">

                            <template slot="table-column" slot-scope="props">
                                <span v-if="isRequiredColumnLabel(props.column.field)">
                                    <div class="custom-header-date">{{props.column.key}}</div> <div class="custom-header-label" v-html="props.column.label">{{props.column.label}}</div>
                                </span>
                                <span v-else>
                                    {{props.column.label}}
                                </span>
                            </template>
                        </vue-good-table>
                    </div>
                </div>
                    <!--page content-->
                    
            </div>
        </template>
        <template v-else>
            <no-permission></no-permission>
        </template>
        <app-footer></app-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    import Vue from 'vue';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import {HTTP} from '../http-common';
    import FrontFooter from '@/components/FrontFooter';
    import NoAccessPermission from '@/components/NoAccessPermission'
    import {commonMixins} from '../mixins/commonMixins';
    import vSelect from 'vue-select';
    import {Datetime} from 'vue-datetime'
    import 'vue-datetime/dist/vue-datetime.css'
    import { now } from 'moment';

    Vue.use(VueGoodTable);

    var self;
    export default {
        name: 'ListTicket',
        mixins: [commonMixins],
        components: {
            'app-footer':FrontFooter,
            'no-permission': NoAccessPermission,
            vSelect,
            datetime: Datetime,
        },
        data() {
            return {
                firstLoad: 0,
                columns: [
                    {
                        label: 'Interval',
                        field: 'interval',
                    },
                    {
                        label: 'Avg Wait Time',
                        field: 'avg_wait_time_in_hh_mm',
                    },
                    {
                        label: 'Numbers Considered',
                        field: 'numbers_considered',
                    }
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 25,
                    sort: {
                        field: 'id',
                        type: 'asc',
                    },
                },
                date_from_backend:[],
                recordsCounts: "",
                selectedRows: 0,
                selectedLocation: null,
                ticketdate:{
                    format:'yyyy-MM-dd'
                },
                ticketData:{
                    //from_date: this.$moment.format('YYYY-MM-DD'),
                    //to_date: this.$moment.format('YYYY-MM-DD')
                },
                time_zone: '',
                time_considered: 'open',
                date_picker_options: {
                    range: true,
                    onlyDate: true,
                    outputFormat: 'YYYY-MM-DD',
                    inputFormat: 'YYYY-MM-DD',
                    formatted: 'MMM DD, YYYY',//'YYYY-MM-DD', 
                    noClearButton: true,
                    maxDate : '',
                    // Getting error when using the for date picker options
                    // 'no-shortcuts': false,
                    customShortcuts : [
                        /* { label: 'Yesterday', value: '-day', isSelected: false },
                        { label: 'This Week', value: 'week', isSelected: false },
                        { label: 'Last Week', value: '-week', isSelected: false },
                        { label: 'This Month', value: 'month', isSelected: false },
                        { label: 'Last Month', value: '-month', isSelected: false }, */
                        { key: 'yesterday', label: 'Yesterday', value: '-day', isSelected: false },
                        { key: 'thisWeek', label: 'This Week', value: 'isoWeek', isSelected: false },
                        { key: 'lastWeek', label: 'Last Week', value: '-isoWeek', isSelected: false },
                        { key: 'thisMonth', label: 'This Month', value: 'month', isSelected: false },
                        { key: 'lastMonth', label: 'Last Month', value: '-month', isSelected: false },
                    ]
                },
                date_picker_dates: {
                    "start": "2019-03-06",
                    "end": "2019-03-27"
                },
                datePickerError : '',
                locationError : '',
                today : '',
            }

        },
        beforeMount: function () {
            self = this;
            //self.checkLogin();
        },
        mounted: function () {
            //self.loadTickets();
            var date = new Date();
            self.time_zone = self.$moment.tz.guess();
            //var start_date = self.formatDate(self.$moment(date).tz(self.time_zone).subtract(7, 'days').toISOString()); // setting start date to previous 7 days
            //var end_date = self.formatDate(self.$moment(date).tz(self.time_zone).toISOString());
            //self.date_picker_dates.start = start_date;
            //self.date_picker_dates.end = end_date;
            let today = new Date();
            let dd = String(today.getDate()).padStart(2, '0');
            let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            let yyyy = today.getFullYear();
            today = yyyy + '-' + mm + '-' + dd;
            self.today = today;
            self.date_picker_dates = {
                start : today,
                end : today,
            };
            self.date_picker_options.maxDate = today;
            self.loadLocations();
        },
        methods: {
            isRequiredColumnLabel: function(label) {
                if(label.includes('avg_wait_time_in_hh_mm') || label.includes('numbers_considered')) {
                    return true;
                }
                return false;
            },
            updateParams(newProps) {
                self.serverParams = Object.assign({}, self.serverParams, newProps);
            },
            selectionChanged() {
                self.selectedRows = (self.$refs['ticketList'].selectedRows).length;
            },
            clearFilter(){
                self.selectedLocation = null;
                self.date_picker_dates.start = '';
                self.date_picker_dates.end = '';
                self.loadTickets();
            },
            onInputDateSelected: function() {
                console.log(JSON.stringify(self.date_picker_dates));
                // return;
            },
            exportTicket : function (e) {
                    
                if (self.checkForm()) {
                    if (self.date_picker_dates.end === null) {
                        self.date_picker_dates.end = self.date_picker_dates.start;
                    }
                    var location_id = 0;
                    if(self.selectedLocation.location_id != 0) {
                        location_id = self.selectedLocation.location_id; 
                    }
                    var startDate = self.date_picker_dates.start.split('-');
                    var endDate = self.date_picker_dates.end.split('-');
                    var startDate0 = ("0" + startDate[0]).slice(-2);
                    var startDate1 = ("0" + startDate[1]).slice(-2);
                    var endDate0 = ("0" + endDate[0]).slice(-2);
                    var endDate1 = ("0" + endDate[1]).slice(-2);
                    self.date_picker_dates.start = startDate0 + '-' + startDate1 + '-' + startDate[2];
                    self.date_picker_dates.end = endDate0 + '-' + endDate1 + '-' + endDate[2];

                    var date_object = {
                        // from_date: self.formatDate(self.date_picker_dates.start),//self.ticketData.from_date),
                        // to_date: self.formatDate(self.date_picker_dates.end),//self.ticketData.to_date)
                        from_date: self.date_picker_dates.start,
                        to_date: self.date_picker_dates.end,
                    };

                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                        params: { 
                            'location_id': location_id,
                            'date': date_object,
                            'time_considered': self.time_considered,
                        }
                    };

                    HTTP.get('ticket/avgwaittime/hourly/export', config)
                        .then(function (response) {
                            if (response.data.code == 200) {
                                // File exported successfully
                                location.href = response.data.content.web;
                            } else if(response.data.code == 404) {
                                alert("No Numbers found for the selected Interval");
                            }
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else if(err.response.status == 404){
                            alert("No Numbers found for the selected Interval");
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    })
                } 
                
            },
            changeLocation: function () {
                let self = this;
                self.locationError = '';
            },
            changeDatePickerDate : function () {
                let self = this;
                self.datePickerError = '';
            },
            checkForm : function () {
                let checked = true;
                let self = this;
                if (self.date_picker_dates.start == '' && self.date_picker_dates.end == '') {
                    self.datePickerError = "Please Select Date";
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.selectedLocation === null) {
                    self.locationError = "Please Select Location";
                    if (checked) {
                        checked = false;
                    }
                }
                return checked;
            },
            loadTickets: function () {
                if (self.checkForm()) {
                    self.firstLoad = 1;
                    if (self.date_picker_dates.end === null) {
                        self.date_picker_dates.end = self.date_picker_dates.start;
                    }
                    var startDate = self.date_picker_dates.start.split('-');
                    var endDate = self.date_picker_dates.end.split('-');
                    var startDate0 = ("0" + startDate[0]).slice(-2);
                    var startDate1 = ("0" + startDate[1]).slice(-2);
                    var endDate0 = ("0" + endDate[0]).slice(-2);
                    var endDate1 = ("0" + endDate[1]).slice(-2);
                    self.date_picker_dates.start = startDate0 + '-' + startDate1 + '-' + startDate[2];
                    self.date_picker_dates.end = endDate0 + '-' + endDate1 + '-' + endDate[2];
                    var date_object = {
                        // from_date: self.formatDate(self.date_picker_dates.start),//self.ticketData.from_date),
                        // to_date: self.formatDate(self.date_picker_dates.end),
                        from_date: self.date_picker_dates.start,//self.ticketData.from_date),
                        to_date: self.date_picker_dates.end,//self.ticketData.to_date)
                    };


                    //self.ticketData.from_date = self.formatDate(self.ticketData.from_date);
                    //self.ticketData.to_date = self.formatDate(self.ticketData.to_date);
                    var location_id = 0;
                    if(self.selectedLocation.location_id != 0) {
                        location_id = self.selectedLocation.location_id;
                    }

                    var config = {
                        headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                        params: {
                            'location_id': location_id,
                            'date': date_object,
                            'time_considered': self.time_considered,
                        }
                    };

                    HTTP.get('ticket/avgwaittime/hourly', config)
                        .then(function (response) {

                            if (response.data.code == 200) {
                                self.columns = [{
                                    label: 'Interval',
                                    field: 'interval',
                                    width: '200px',
                                    key: "interval",
                                }];

                                // This dates will define Column Headers
                                self.date_from_backend = response.data.content.date;
                                //console.log(self.date_from_backend);
                                //return;

                                // Looping through dates to generate Column Headers (VueGoodTable fields)

                                for (var key in self.date_from_backend) {

                                    var dow = self.$moment(key).format('ddd');
                                    var day = self.$moment(key).format('Do');
                                    var month = self.$moment(key).format('MMM');
                                    //console.log(dow);
                                    var data = {
                                        label: 'Avg Wait Time ',
                                        field: 'avg_wait_time_in_hh_mm' + key,
                                        width: '100px',
                                        key: dow + ',' + month + ' ' + day,
                                    }

                                    self.columns.push(data);

                                    data =  {
                                        label: 'Numbers <br> Considered ',
                                        field: 'numbers_considered' + key,
                                        width: '100px',
                                        html: 'true',
                                    }

                                    self.columns.push(data);
                                }


                                self.rows = response.data.content.row;
                                self.totalRecords = response.data.content.totalRecords;

                            }
                        })
                        .catch(function (err) {
                            console.log(err);
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        })
                }
            },
        },
        computed: {
            minDateTime: function() {
                var temp = this.$moment(self.formatDate(self.ticketData.to_date), 'YYYY-MM-DD');
                var minDate = this.$moment(temp).subtract(7, 'days');
                return minDate.toISOString();
            },
            maxDateTime: function() {
                var temp = this.$moment(self.formatDate(self.ticketData.from_date), 'YYYY-MM-DD');
                var maxDate = this.$moment(temp).add(7, 'days');
                return maxDate.toISOString();
            }
        },
        watch: {
            // date_picker_dates: function(val) {
            //     if (val.start === self.today) {
            //         self.date_picker_options.max_allowed_days = 0;
            //         val.end = self.today;
            //     } else {
            //         self.date_picker_options.max_allowed_days = 7;
            //     }
            //     // mostly we get start date and on the basis of that we decide end date
            //     if(val.start != null) {
            //         var end_date = self.formatDate(self.$moment(val.start).tz(self.time_zone).add(self.date_picker_options.max_allowed_days, 'days').toISOString()); // setting start date to previous 7 days
            //         self.date_picker_dates.end = end_date;
            //     } else if(val.end != null) {
            //         var start_date = self.formatDate(self.$moment(val.end).tz(self.time_zone).subtract(self.date_picker_options.max_allowed_days, 'days').toISOString()); // setting start date to previous 7 days
            //         self.date_picker_dates.start = start_date;
            //     }
            // }
        }
    }
</script>
<style>
    body {
        margin: 0;
        padding: 0;
        font-family: 'SanFranciscoDisplayRegular' !important;
        background: #f5f5f5 !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/HourlyReport.vue